<template>
  <div class="fixed-menu" id="JS_FIXED_MENU">
    <ul class="fixed-menu__list">
      <li
        class="fixed-menu__item configurator js_hoverTarget"
        data-id="configurator"
        v-bind:style="'order:' + sp_dealer_icon_order_configurator"
      >
        <a href="https://www.renault.jp/configurator/"
          ><span class="fixed-menu__txt"
            >コンフィギュ<br class="u-hidden-up-md" />レーター</span
          ></a
        >
      </li>
      <li
        class="fixed-menu__item drive js_hoverTarget"
        data-id="drive"
        v-show="testdrive_id"
        v-bind:style="'order:' + sp_dealer_icon_order_testdrive"
      >
        <a v-show="testdrive_id" :href="url"
          ><span class="fixed-menu__txt">試乗予約</span></a
        >
      </li>
      <li
        class="fixed-menu__item counseling js_hoverTarget"
        data-id="counseling"
        :style="'order:' + sp_dealer_icon_order_counseling"
      >
        <a :href="url3"><span class="fixed-menu__txt">購入相談</span></a>
      </li>
      <li
        class="fixed-menu__item dealer js_hoverTarget"
        data-id="dealer"
        :style="'order:' + sp_dealer_icon_order_dealer"
      >
        <a href="/support/dealer_map.html"
          ><span class="fixed-menu__txt">ディーラー検索</span></a
        >
      </li>
      <li
        class="fixed-menu__item catalog js_hoverTarget"
        data-id="catalog"
        v-show="catalog_id"
        v-bind:style="'order:' + sp_dealer_icon_order_catalog"
      >
        <a v-show="catalog_id" :href="url2"
          ><span class="fixed-menu__txt">カタログ請求</span></a
        >
      </li>
      <li
        class="fixed-menu__item fixed-menu__item--bnr sideBnr01"
        :style="'order:' + sp_dealer_icon_order_mbr"
      >
        <transition name="fade" v-if="car_sidebannaer.length === 1">
          <div :key="car_sidebannaer[0].src[index]">
            <a :href="car_sidebannaer[0].href[index]">
              <img :src="car_sidebannaer[0].src[index]" />
            </a>
          </div>
        </transition>
      </li>
    </ul>
    <ul class="fixed-menu__slideList">
      <li>
        <a
          class="fixed-menu__slideLink js_hoverTarget"
          href="https://www.renault.jp/configurator/"
          data-id="configurator"
          >コンフィギュレーター</a
        >
      </li>
      <li v-show="testdrive_id">
        <a
          class="fixed-menu__slideLink js_hoverTarget"
          :href="url"
          data-id="drive"
          >試乗予約</a
        >
      </li>
      <li>
        <a
          class="fixed-menu__slideLink js_hoverTarget"
          :href="url3"
          data-id="counseling"
          >購入相談</a
        >
      </li>
      <li>
        <a
          class="fixed-menu__slideLink js_hoverTarget"
          href="/support/dealer_map.html"
          data-id="dealer"
          >ディーラー検索</a
        >
      </li>
      <li v-show="catalog_id">
        <a
          class="fixed-menu__slideLink js_hoverTarget"
          :href="url2"
          data-id="catalog"
          >カタログ請求</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
import { onMounted, ref, props, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  props: ["td_id", "car_id", "p_url"],
  setup(props) {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const carJson = store.state;
    const index = ref(0);
    const sidebanner_url = carJson.SIDEBANNER.lists;
    let number = ref(props.td_id);
    let car_id = ref(props.car_id);
    let p_url  = ref(props.p_url);
    let url = "https://www.renault.jp/support/test_drive.php";
    let url2 = "https://www.renault.jp/support/catalog.php";
    let url3 = "https://www.renault.jp/support/purchase.php";
    let car_sidebannaer;
    let catalog_id = true;
    let testdrive_id = true;
    let sp_dealer_icon_order_testdrive = 1; //SP版のときディーラー検索アイコンを中央に置く
    let sp_dealer_icon_order_dealer = 2; //ディーラーは常に2番目
    let sp_dealer_icon_order_counseling = 3;
    let sp_dealer_icon_order_catalog = 4;
    let sp_dealer_icon_order_configurator = 5;
    let sp_dealer_icon_order_mbr = 6;

    const getSidebannerId = () => {
      if (number.value !== "") {
        url =
          "https://www.renault.jp/support/test_drive.php?td_id=" + number.value;
      } else {
        testdrive_id = false;
      }

      if (car_id.value !== "") {
        url2 =
          "https://www.renault.jp/support/catalog.php?carid=" + car_id.value;
      } else {
        catalog_id = false;
      }
      
      if (p_url.value !== "" && p_url.value !== undefined) {
          url3 = p_url.value;
      }
    };

//  2025/07/22 カタログ請求 削除
    catalog_id = false;

    const setIconOrder = () => {
      if (testdrive_id == false && catalog_id == false) {
        sp_dealer_icon_order_testdrive = 0;
        sp_dealer_icon_order_dealer = 2;
        sp_dealer_icon_order_catalog = 0;
        sp_dealer_icon_order_configurator = 1; //カーコンフィギュが左端・ディーラー検索が中央
        sp_dealer_icon_order_mbr = 3;
      } else if (testdrive_id == false) {
        sp_dealer_icon_order_testdrive = 0;
        sp_dealer_icon_order_dealer = 2;
        sp_dealer_icon_order_catalog = 1;
        sp_dealer_icon_order_configurator = 3; //カタログが左端・ディーラー検索が中央・コンフィギュが右端
        sp_dealer_icon_order_mbr = 4;
      } else if (catalog_id == false) {
        sp_dealer_icon_order_testdrive = 1;
        sp_dealer_icon_order_dealer = 2;
        sp_dealer_icon_order_catalog = 0;
        sp_dealer_icon_order_configurator = 3; //試乗申込が左端・ディーラー検索が中央・コンフィギュが右端
        sp_dealer_icon_order_mbr = 4;
      } else {
        sp_dealer_icon_order_testdrive = 1;
        sp_dealer_icon_order_dealer = 2;
        sp_dealer_icon_order_catalog = 3;
        sp_dealer_icon_order_configurator = 4; //試乗申込が左端・ディーラー検索が左から2番目・カタログが左から3番目・コンフィギュが右端
        sp_dealer_icon_order_mbr = 5;
      }
    };

    const getSideBannearImage = () => {
      if (route.query.code !== undefined) {
        for (let i = 0; i < sidebanner_url.length; i++) {
          car_sidebannaer = sidebanner_url.filter(
            (list) => list.code === route.query.code && list.active === "true"
          );
        }
      } else {
        car_sidebannaer = sidebanner_url.filter(
          (list) => list.code === "ALL" && list.active === "true"
        );
      }
    };
    const changeSideBanner = () => {
      if (car_sidebannaer.length !== 0) {
        setInterval(() => {
          index.value =
            index.value < car_sidebannaer[0].src.length - 1
              ? index.value + 1
              : 0;
        }, 5000);
      }
    };

    getSidebannerId();
    getSideBannearImage();
    setIconOrder();

    onMounted(() => {
      changeSideBanner();
      //イージング処理(rj_common.jsより移植)
      var rj_common = {
        breakpoint: [560, 768, 1280],
        getDesktop: function () {
          if (!window.matchMedia) {
            return;
          }
          if (
            window.matchMedia("(min-width:" + this.breakpoint[2] + "px)")
              .matches
          ) {
            return true;
          } else {
            return false;
          }
        },
        getTablet: function () {
          if (!window.matchMedia) {
            return;
          }
          if (
            window.matchMedia("(min-width:" + this.breakpoint[1] + "px)")
              .matches
          ) {
            return true;
          } else {
            return false;
          }
        },
        getSmartphoneV: function () {
          if (!window.matchMedia) {
            return;
          }
          if (
            window.matchMedia("(max-width:" + this.breakpoint[0] + "px)")
              .matches
          ) {
            return true;
          } else {
            return false;
          }
        },
      };
      var FixedMenu = {
        tgt: null,
        global_menu_h: 0,
        page_menu_h: 0,
        this_margin_top: 16,
        scroll_y: 0,
        pc_flag: !0,
        update: function () {
          this.pc_flag
            ? ((this.scroll_y = $(window).scrollTop()),
              this.scroll_y > this.global_menu_h
                ? this.tgt.css({
                    position: "fixed",
                    top: this.this_margin_top + this.page_menu_h + "px",
                  })
                : this.tgt.css({
                    position: "absolute",
                    top:
                      this.global_menu_h +
                      this.this_margin_top +
                      this.page_menu_h +
                      "px",
                  }))
            : this.tgt.css({
                position: "fixed",
                top: "auto",
              });
        },
        set: function () {
          (this.global_menu_h = $(".global-menu").height()),
            $(".car-menu").height()
              ? (this.page_menu_h = $(".car-menu").height())
              : $(".js_pagemenu_fixed").height() &&
                (this.page_menu_h = $(".js_pagemenu_fixed").height());
        },
        check: function () {
          rj_common.getDesktop()
            ? this.pc_flag || (this.set(), (this.pc_flag = !0), this.update())
            : this.pc_flag && ((this.pc_flag = !1), this.update());
        },
        init: function () {
          var t = this;
          (this.tgt = $("#JS_FIXED_MENU")),
            this.set(),
            this.check(),
            this.update(),
            $(window).on("scroll", function () {
              t.update();
            }),
            $(window).resize(function () {
              t.check();
            });
        },
      }.init();
      function isTouchDevice() {
        var result = false;
        if (window.ontouchstart === null) {
          result = true;
        }
        return result;
      }

      document.querySelectorAll(".js_hoverTarget").forEach(function (t) {
        t.addEventListener("mouseover", function () {
          document
            .querySelector("." + t.dataset.id)
            .classList.add("is_current");
        }),
          t.addEventListener("mouseout", function () {
            document
              .querySelector("." + t.dataset.id)
              .classList.remove("is_current");
          });
      });
    });

    return {
      sidebanner_url,
      index,
      number,
      car_id,
      url,
      url2,
      url3,
      car_sidebannaer,
      catalog_id,
      testdrive_id,
      sp_dealer_icon_order_testdrive,
      sp_dealer_icon_order_dealer,
      sp_dealer_icon_order_catalog,
      sp_dealer_icon_order_configurator,
      sp_dealer_icon_order_mbr,
      sp_dealer_icon_order_counseling,
    };
  },
};
</script>